<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label"
        :hint="hint"
        :rules="rules"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        clearable
        outlined
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :rules="rules"
      @input="updateValue"
      :allowedDates="allowedDates"
      no-title
      scrollable
    >
      <template v-if="hasConfirmBtn">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="updateValue"
        >
          OK
        </v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from 'moment'
export default {
  data: () => ({
    defaultDateFormat: 'yyyy-MM-DD',
    date: null,
    menu: false
  }),
  created () {
    this.date = this.toDate(new Date())
  },
  computed: {
    allowedDates () {
      return this.typeConfig.allowedDates || null
    },
    rules () {
      return this.typeConfig.rules || []
    },
    hasConfirmBtn () {
      return this.typeConfig.hasConfirmBtn || false
    },
    dateFormat () {
      return this.typeConfig.dateFormat || this.defaultDateFormat
    },
    timeFormat () {
      return this.typeConfig.timeFormat || this.defaultTimeFormat
    },
    datetimeFormat () {
      return this.typeConfig.dateTimeFormat || this.defaultDateTimeFormat
    },
    dateValue () {
      return this.toDate(this.value1)
    },
    timeValue () {
      return this.toTime(this.value2)
    }
  },
  methods: {
    updateValue (newvalue) {
      console.log('updateValue', newvalue)
      // this.date = this.toDate(newvalue)
      this.$refs.menu.save(this.date)
      this.$emit('input', this.date)
      // console.log('emit', this.date)
    },
    toDate (date) {
      return moment(date).format(this.dateFormat)
    }
  },
  props: {
    typeConfig: {
      type: Object,
      default () {
        return {
          hasConfirmBtn: false,
          dateFormat: null,
          timeFormat: null,
          dateTimeFormat: null
        }
      }
    },
    value: {},
    label: {},
    hint: {}
  },
  watch: {
    value (newvalue, oldvalue) {
      if (newvalue) {
        this.date = this.toDate(new Date(newvalue))
      } else {
        this.date = null
      }
      // this.updateValue(newvalue)
    }
  }
}
</script>
